import { Component, input, model, OnDestroy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

@Component({
  selector: 'dbx-search',
  imports: [ReactiveFormsModule, MatInputModule, MatFormFieldModule, MatIconModule, TranslateModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  standalone: true,
})
export class SearchComponent implements OnDestroy {
  search = model.required<string>();
  placeholder = input<string>('');

  searchControl = new FormControl();

  private destroy$ = new Subject<void>();

  constructor() {
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        takeUntil(this.destroy$),
        tap((searchText) => this.search.set(searchText ?? '')),
      )
      .subscribe();
  }

  clear(): void {
    this.searchControl.patchValue('');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected readonly Math = Math;
}
